import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e876cf0")

_pushScopeId("data-v-6e876cf0")
const _hoisted_1 = { class: "col-md-12 tableOpacity" }
const _hoisted_2 = { class: "card mb-5 card-p " }
const _hoisted_3 = { class: "card-header-title mb-5 p-0 " }
const _hoisted_4 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "60%",
  height: "18"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "36",
  height: "36"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("rect", {
  x: "48",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "36%",
  height: "18"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("rect", {
  x: "48",
  y: "22",
  rx: ".25rem",
  ry: ".25rem",
  width: "44%",
  height: "14"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("rect", {
  x: "74%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "26%",
  height: "36"
}, null, -1)
const _hoisted_9 = { class: "card mb-5 card-p" }
const _hoisted_10 = { class: "card-header-title mb-6 p-0 " }
const _hoisted_11 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "70%",
  height: "18"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "14"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("rect", {
  x: "60%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "40%",
  height: "14"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "30",
  rx: ".25rem",
  ry: ".25rem",
  width: "30%",
  height: "14"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("rect", {
  x: "70%",
  y: "30",
  rx: ".25rem",
  ry: ".25rem",
  width: "30%",
  height: "14"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "60",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "14"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("rect", {
  x: "80%",
  y: "60",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "14"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "90",
  rx: ".25rem",
  ry: ".25rem",
  width: "40%",
  height: "14"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("rect", {
  x: "50%",
  y: "90",
  rx: ".25rem",
  ry: ".25rem",
  width: "50%",
  height: "14"
}, null, -1)
const _hoisted_20 = { class: "card mb-5 card-p" }
const _hoisted_21 = { class: "card-header-title mb-6 p-0 " }
const _hoisted_22 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "50%",
  height: "18"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "30%",
  height: "16"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("rect", {
  x: "35%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "40%",
  height: "16"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("rect", {
  x: "80%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "30",
  rx: ".25rem",
  ry: ".25rem",
  width: "30%",
  height: "16"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("rect", {
  x: "35%",
  y: "30",
  rx: ".25rem",
  ry: ".25rem",
  width: "40%",
  height: "16"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("rect", {
  x: "80%",
  y: "30",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "60",
  rx: ".25rem",
  ry: ".25rem",
  width: "30%",
  height: "16"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("rect", {
  x: "35%",
  y: "60",
  rx: ".25rem",
  ry: ".25rem",
  width: "40%",
  height: "16"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("rect", {
  x: "80%",
  y: "60",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_32 = { class: "card mb-5 card-p" }
const _hoisted_33 = { class: "card-header-title mb-6 p-0" }
const _hoisted_34 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "50%",
  height: "18"
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "30%",
  height: "16"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("rect", {
  x: "35%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "40%",
  height: "16"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("rect", {
  x: "80%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "30",
  rx: ".25rem",
  ry: ".25rem",
  width: "30%",
  height: "16"
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("rect", {
  x: "35%",
  y: "30",
  rx: ".25rem",
  ry: ".25rem",
  width: "40%",
  height: "16"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("rect", {
  x: "80%",
  y: "30",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "60",
  rx: ".25rem",
  ry: ".25rem",
  width: "30%",
  height: "16"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("rect", {
  x: "35%",
  y: "60",
  rx: ".25rem",
  ry: ".25rem",
  width: "40%",
  height: "16"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("rect", {
  x: "80%",
  y: "60",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_content_loader, {
          viewBox: "0 0 400 18",
          preserveAspectRatio: "none",
          width: "100%",
          height: "18",
          speed: 2,
          primaryColor: "#ababab",
          secondaryColor: "#cccccc"
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createVNode("div", null, [
        _createVNode(_component_content_loader, {
          viewBox: "0 0 400 36",
          preserveAspectRatio: "none",
          width: "100%",
          height: "36",
          speed: 2,
          primaryColor: "#ababab",
          secondaryColor: "#cccccc"
        }, {
          default: _withId(() => [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_content_loader, {
          viewBox: "0 0 400 18",
          preserveAspectRatio: "none",
          width: "100%",
          height: "18",
          speed: 2,
          primaryColor: "#ababab",
          secondaryColor: "#cccccc"
        }, {
          default: _withId(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      _createVNode("div", null, [
        _createVNode(_component_content_loader, {
          viewBox: "0 0 400 104",
          preserveAspectRatio: "none",
          width: "100%",
          height: "104",
          speed: 2,
          primaryColor: "#ababab",
          secondaryColor: "#cccccc"
        }, {
          default: _withId(() => [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode("div", _hoisted_21, [
        _createVNode(_component_content_loader, {
          viewBox: "0 0 400 18",
          preserveAspectRatio: "none",
          width: "100%",
          height: "18",
          speed: 2,
          primaryColor: "#ababab",
          secondaryColor: "#cccccc"
        }, {
          default: _withId(() => [
            _hoisted_22
          ]),
          _: 1
        })
      ]),
      _createVNode("div", null, [
        _createVNode(_component_content_loader, {
          viewBox: "0 0 400 76",
          preserveAspectRatio: "none",
          width: "100%",
          height: "76",
          speed: 2,
          primaryColor: "#ababab",
          secondaryColor: "#cccccc"
        }, {
          default: _withId(() => [
            _hoisted_23,
            _hoisted_24,
            _hoisted_25,
            _hoisted_26,
            _hoisted_27,
            _hoisted_28,
            _hoisted_29,
            _hoisted_30,
            _hoisted_31
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_32, [
      _createVNode("div", _hoisted_33, [
        _createVNode(_component_content_loader, {
          viewBox: "0 0 400 18",
          preserveAspectRatio: "none",
          width: "100%",
          height: "18",
          speed: 2,
          primaryColor: "#ababab",
          secondaryColor: "#cccccc"
        }, {
          default: _withId(() => [
            _hoisted_34
          ]),
          _: 1
        })
      ]),
      _createVNode("div", null, [
        _createVNode(_component_content_loader, {
          viewBox: "0 0 400 76",
          preserveAspectRatio: "none",
          width: "100%",
          height: "76",
          speed: 2,
          primaryColor: "#ababab",
          secondaryColor: "#cccccc"
        }, {
          default: _withId(() => [
            _hoisted_35,
            _hoisted_36,
            _hoisted_37,
            _hoisted_38,
            _hoisted_39,
            _hoisted_40,
            _hoisted_41,
            _hoisted_42,
            _hoisted_43
          ]),
          _: 1
        })
      ])
    ])
  ]))
})